<template>
  <div class="metric-form">
    <MetricSelect
      :value="selectedMetric"
      label="Number Metric*"
      required
      :items="numberMetricOptions"
      data-testid="metric-field-informMetricId"
      @input="setMetric"
    />
    <MetricSelect
      :value="value.prefixLabelAttribute"
      label="Prefix Label"
      hint="Appears before the metric (e.g. $)"
      :items="metricOptions"
      data-testid="metric-field-prefixLabelAttribute"
      @input="setField('prefixLabelAttribute', $event)"
    />
    <MetricSelect
      :value="value.suffixLabelAttribute"
      label="Suffix Label"
      hint="Appears after the metric (e.g. pts, %)"
      :items="metricOptions"
      data-testid="metric-field-suffixLabelAttribute"
      @input="setField('suffixLabelAttribute', $event)"
    />
    <MetricSelect
      :value="value.labelAttribute"
      label="Label"
      hint="Appears below the metric (e.g. Total Sales)"
      :items="metricOptions"
      data-testid="metric-field-labelAttribute"
      @input="setField('labelAttribute', $event)"
    />
  </div>
</template>

<script>
import MetricSelect from "./MetricSelect.vue";
import {
  hasMetricBinding,
  toMetricBinding,
  toMetricSelectValue,
  withParticipantEarnings,
} from "./metricOptions";

export default {
  name: "NumberMetricForm",
  components: { MetricSelect },
  props: {
    value: { type: Object, required: true },
    metricOptions: { type: Array, default: () => [] },
    informProgramId: { type: String, default: null },
  },
  emits: ["input", "update:valid"],
  computed: {
    numberMetricOptions() {
      return withParticipantEarnings(this.metricOptions);
    },
    selectedMetric() {
      return toMetricSelectValue(this.value, this.numberMetricOptions);
    },
    isValid() {
      return hasMetricBinding(this.value);
    },
  },
  watch: {
    isValid: {
      immediate: true,
      handler(valid) {
        this.$emit("update:valid", valid);
      },
    },
  },
  methods: {
    setMetric(selectValue) {
      this.$emit("input", {
        ...this.value,
        ...toMetricBinding(selectValue, this.numberMetricOptions, this.informProgramId),
      });
    },
    setField(key, fieldValue) {
      this.$emit("input", { ...this.value, [key]: fieldValue });
    },
  },
};
</script>

<style scoped>
.metric-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
